import { FunctionComponent } from 'react';
import classnames from 'classnames';

// Components
import SearchLayout from '@Components/Layout/Search';
import LayoutContainer from '@Components/Layout/Components/Container';
import Breadcrumb, { PathLevelProps } from '@Components/UI/Breadcrumb';
import LayoutResult from '@Components/Layout/Search/Components/LayoutResult';
import BannerRight from '@Pages/bai-viet/Components/Layout/Components/BannerRight';
import SearchUI, { SearchUIProps } from '@Components/Layout/Search/Components/SearchUI';

// Contexts
import { withCategoryStore } from '@Components/Categories/Context';
import { ViewMedia, useViewDetected } from '@Components/Utils/ViewDetected';

// Styles
import styles from './ResultPost.module.scss';

interface ResultPostProps {
    keyword?: string;
    isEmpty?: boolean;
    className?: string;
    placeholder?: string;
    paths?: Array<PathLevelProps>;
    onSearch?: (keyword: string) => void;
}

const ResultPost: FunctionComponent<SearchUIProps & ResultPostProps> = ({
    paths,
    title,
    keyword,
    subTitle,
    children,
    className,
    placeholder,
    onSearch,
    // ...props
}) => {
    const { deviceType } = useViewDetected();

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        className,
    ]);

    return (
        <SearchLayout className={wrapperClassName} placeholder={placeholder} onSearch={onSearch} keyword={keyword}>
            <LayoutContainer className={styles.breadcrumb}>
                <Breadcrumb paths={paths} />
            </LayoutContainer>

            <ViewMedia is={'desktop'}>
                <div className={styles.search_wrapper}>
                    <SearchUI
                        title={title}
                        keyword={keyword}
                        subTitle={subTitle}
                        onSearch={onSearch}
                        className={styles.search}
                        placeholder={placeholder}
                        titleClassName={styles?.title}
                        subTitleClassName={styles.sub_title}
                    />
                </div>
            </ViewMedia>

            <div className={styles.body}>
                <LayoutResult
                    extendComponent={<BannerRight />}
                    className={styles.layout_container}
                    hasExtendComponent={deviceType === 'desktop'}
                >
                    {children}
                </LayoutResult>
            </div>
        </SearchLayout>
    );
};

ResultPost.defaultProps = {
    paths: [],
    keyword: '',
    isEmpty: false,
    title: 'Kết quả tìm kiếm',
    placeholder: 'Tìm kiếm ngay...',
    subTitle: (
        <span>
            Dưới đây là những <b>bài viết</b> phù hợp với từ khóa của bạn.
        </span>
    ),
};

export default withCategoryStore(ResultPost);
